import React, { useContext } from "react";
import SearchHeader from "./SearchHeader";
import { useState } from "react";
import { auth } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState(false);
  const [password, setPassword] = useState(false);
  const handleClick = (e) => {
    e.preventDefault();

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        dispatch({ type: "LOGIN", payload: user });
        alert("Logged In");
        console.log(user);
        navigate("/");
        navigate("/restaurant");
        localStorage.setItem("email", user.email);
      })
      .catch((error) => {
        setError(true);
      });
  };
  return (
    <div>
      <SearchHeader />
      <div className="container py-5 mt-5 d-flex justify-content-center">
        <form onSubmit={handleClick}>
          <div className="form-outline mb-4">
            <input
              type="email"
              id="form2Example1"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />
            <label className="form-label">Email address</label>
          </div>

          <div className="form-outline mb-4">
            <input
              type="password"
              id="form2Example2"
              className="form-control"
              onChange={(e) => setPassword(e.target.value)}
            />
            <label className="form-label">Password</label>
          </div>

          <button type="submit" className="btn btn-primary btn-block mb-4">
            Sign in
          </button>

          <div className="text-center">
            <p>
              Not a member? <Link to={"/register"}>Register</Link>
            </p>

            {error && <p className="text-danger">Wrong Password or email Id</p>}
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
